export default __webpack_public_path__ + "static/media/check_circle.4cfa32d4.svg";